<!-- @format -->

<sis-expandable
  [title]="attainmentGroupNode.name | localizedString"
  [closed]="false"
  [level]="headingLevel"
  [size]="getHeadingSize()"
  [contentPadding]="'small'"
  [variant]="'naked-dotted'"
  [disabled]="headingLevel !== 3"
  [hideIcon]="headingLevel !== 3">
  <ng-template sisExpandableContent>
    <sis-plan-structure-attainment-node-structure
      [attainmentNodes]="attainmentGroupNode.nodes"
      [planStateObject]="planStateObject"
      [planData]="planData"
      [headingLevel]="headingLevel + 1">
    </sis-plan-structure-attainment-node-structure>
  </ng-template>
</sis-expandable>
